import { Label } from '../ui/label';
import { Checkbox } from '../ui/checkbox';

const MANAGER_TYPES = ['surveyor', 'admin'];
const FIELD_TYPES = ['employee', 'sub_contractor'];

function PickList({ options, selectedIds, onToggle, emptyText, testPrefix }) {
  return (
    <div className="max-h-40 overflow-y-auto space-y-1.5 bg-[#1E2530] p-3 rounded-lg">
      {options.length === 0 ? (
        <p className="text-gray-500 text-sm">{emptyText}</p>
      ) : options.map(o => (
        <div
          key={o.id}
          className="flex items-center gap-3 p-1.5 hover:bg-white/5 rounded cursor-pointer"
          onClick={() => onToggle(o.id)}
          data-testid={`${testPrefix}-${o.id}`}
        >
          <Checkbox
            checked={selectedIds.includes(o.id)}
            className="border-white/30 data-[state=checked]:bg-[#F5A623] data-[state=checked]:border-[#F5A623]"
          />
          <span className="text-white text-sm flex-1">{o.name}</span>
          <span className="text-[11px] text-gray-500 capitalize">{o.user_type === 'sub_contractor' ? 'Sub-contractor' : o.user_type}</span>
        </div>
      ))}
    </div>
  );
}

/**
 * Two-way team link. A contractor is "available" to the surveyors/admins in
 * their `assigned_surveyor_ids`; the same link seen from the manager's side is
 * "contractors available to this user". Both edit the same relationship.
 */
export function StaffTeamPicker({ userType, users, staff, managerIds, contractorIds, onManagersChange, onContractorsChange, variant }) {
  const toggle = (list, setter) => (id) => setter(list.includes(id) ? list.filter(x => x !== id) : [...list, id]);

  if (FIELD_TYPES.includes(userType)) {
    const managers = (users || []).filter(u => MANAGER_TYPES.includes(u.user_type));
    return (
      <div className="space-y-2" data-testid={`staff-surveyor-assign-${variant}`}>
        <Label className="text-gray-300">Available to surveyor(s) / admin(s)</Label>
        <p className="text-xs text-gray-500">Surveyors only see their own team in the schedule picker. Admins always see everyone but can still keep a team for the weekly flags.</p>
        <PickList options={managers} selectedIds={managerIds} onToggle={toggle(managerIds, onManagersChange)} emptyText="No surveyors or admins yet" testPrefix={`staff-surveyor-opt-${variant}`} />
      </div>
    );
  }

  if (MANAGER_TYPES.includes(userType)) {
    const contractors = (staff || []).filter(u => FIELD_TYPES.includes(u.user_type));
    return (
      <div className="space-y-2" data-testid={`staff-team-assign-${variant}`}>
        <div className="flex items-center justify-between">
          <Label className="text-gray-300">Contractors available to this user</Label>
          <span className="text-xs text-gray-500" data-testid={`staff-team-count-${variant}`}>{contractorIds.length} selected</span>
        </div>
        <p className="text-xs text-gray-500">Who this user can put on the schedule. The 'not scheduled this week' flag only clears once someone (this user or anyone else) gives them a job.</p>
        <PickList options={contractors} selectedIds={contractorIds} onToggle={toggle(contractorIds, onContractorsChange)} emptyText="No employees or sub-contractors yet" testPrefix={`staff-team-opt-${variant}`} />
      </div>
    );
  }
  return null;
}
